import { render, staticRenderFns } from "./DeleteCautionRole.vue?vue&type=template&id=94e5c240&"
import script from "./DeleteCautionRole.vue?vue&type=script&lang=js&"
export * from "./DeleteCautionRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports